/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { AbstractControl } from '@angular/forms';

export class FormValidators {

	/**
	* Verify that two fields match for setting a password. Note the field names are
	* hard-coded and the controls must be part of a FormGroup object
	*/
  static passwordMatchValidator(c: AbstractControl): { [key: string]: any } {
    let group = c.root;
    let controls = group['controls'];
    if (controls) {
      let pw1 = controls['pw1'];
      if (controls['pw1'].value != controls['pw2'].value) {
        return {
          matchValidator: false
        }
      }
    }
    return null;
  }

	/**
	* Verifies that a password meets minimum requirements
	*/
  static passwordRequirementValidator(c: AbstractControl): { [key: string]: any } {
    var upper = /[A-Z]+/.test(c.value) ? 1: 0;
    var lower = /[a-z]+/.test(c.value) ? 1: 0;
    var num = /[0-9]+/.test(c.value) ? 1: 0;

    if (upper + lower + num < 2) {
      return {
        minimumRequirementValidator: false
      }
    }

    return null;
  }

	/**
	* Verifies that a password meets minimum requirements
	*/
  static businessEmailValidator(c: AbstractControl): { [key: string]: any } {
    var bad = /(@gmail\.com\b|@yahoo\.com\b|@hotmail\.com\b|@outlook\.com\b|@aol\.com\b|@mail\.com\b)/.test(c.value);
    if (bad) {
      return {
        businessEmailValidator: false
      }
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./client/app/global/form-validators.ts